// extracted by mini-css-extract-plugin
export default {"list-item":"checklist-item_list-item__GKOad","checkmark-icon":"checklist-item_checkmark-icon__J2Ql2"};